import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { ChbkClaimLineList } from '@/sc/entities/chbkClaimLine/ChbkClaimLineList';


export const ChbkClaimDetail = () => {
  
  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'chbkClaimLine', label: 'Lines', content: <ChbkClaimLineList chbkClaimObj={entityObj}/>},
    { id: 'val', label: 'Validations', content: <ValList parentEntity="CHBK_CLAIM" parentEntityId={entityObj.id} />},
    { id: 'soxControlsTab', label: 'SOX Controls', content: <EntityControlList parentEntity="CHBK_CLAIM" parentEntityId={entityObj.id} /> }
  ];


  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}